import { Suspense, useContext, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import StepWizard from 'react-step-wizard';
import { RequestContext } from '../../context/RequestContext';
import { DistributorSelect } from '../../pages/DistributorSelect';
import { Documents } from '../../pages/Documents';
import { MaterialsSelect } from '../../pages/MaterialsSelect';
import { CustomStepWizardNav } from '../CustomStepWizardNav';
import ErrorBoundary from '../ErrorBoundary';
import { ErrorComponent } from '../ErrorComponent';

export const BranchesModal = ({
    isModalButtonDisabled,
    selectedBranchId,
}: {
    isModalButtonDisabled: boolean;
    selectedBranchId: number;
}) => {
    const { showModal, setShowModal } = useContext(RequestContext);

    const { t } = useTranslation('translation', { keyPrefix: 'common' });

    return (
        <>
        
            <div className='branch-action-button w-100 d-flex justify-content-end p-2 pe-4 '>
                <Button
                    variant='dark'
                    className='w-100'
                    onClick={() => {
                        setShowModal(true);
                    }}
                    disabled={isModalButtonDisabled}
                >
                    {t('next')}
                </Button>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg' centered className='branches-modal'>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className='p-0'>
                    <Suspense
                        fallback={
                            <div className='wizard-content d-flex justify-content-center align-items-center'>
                                <Spinner animation='border' style={{ width: '2rem' }} />
                            </div>
                        }
                    >
                        <ErrorBoundary fallback={<ErrorComponent errorText={t('distributor')} />}>
                            <StepWizard
                                className='step-wizard d-flex flex-wrap w-100'
                                nav={<CustomStepWizardNav steps={['distributor', 'materials', 'documents']} />}
                                transitions={{
                                    enterRight: '',
                                    enterLeft: '',
                                    exitRight: '',
                                    exitLeft: '',
                                }}
                            >
                                <DistributorSelect stepName='distributor' />
                                <MaterialsSelect stepName='materials' />
                                <Documents stepName='documents'></Documents>
                            </StepWizard>
                        </ErrorBoundary>
                    </Suspense>
                </Modal.Body>
            </Modal>
        </>
    );
};
